// extracted by mini-css-extract-plugin
export var productImage = "_q8-1";
export var viewLink = "_q8-2";
export var wishlistItem = "_q8-0";